export default __webpack_public_path__ + "static/media/carret-down.375f7ba1.svg";